import PostPaymentUpsellOffer from './PostPaymentUpsellOffer';

export default PostPaymentUpsellOffer;
